// PdftotxtConfig.ts
import { BooleanOption, AccordionItem, PanelConfig } from '../types/config';

export const booleanOptions: BooleanOption[] = [
  { label: 'True', value: 'True' },
  { label: 'False', value: 'False' }
];

export const accordionItems: AccordionItem[] = [
  {
    title: "Come funziona?",
    images: [
      {
        url: "/zip_file_brand.png",
        subtitle: "Step 1",
        variableSubtitle: "Seleziona il file PDF che si desidera caricare e fai clic sul pulsante di caricamento."
      },
      {
        url: "/fill_file_brand.png",
        subtitle: "Step 2",
        variableSubtitle: "Verifica che il file sia stato caricato correttamente e compila i campi obbligatori. Clicca sul pulsante 'Converti File'."
      },
      {
        url: "/robotic_brand.png",
        subtitle: "Step 3",
        variableSubtitle: "Attendi la comparsa della preview nel lato destro della schermata e scarica successivamente il file convertito."
      }
    ]
  }
];

export const panelConfig: PanelConfig = {
  title: "PDF to TXT",
  brightnessOnHover: 90,
  imageUrl: 'pdf_to_txt_smallversion.png'
};